export default __webpack_public_path__ + "static/media/manager.6e53e635.svg";